import { IUsageDataMRPCRequestParams } from 'multirpc-sdk';

import { StatsTimeframe } from '../types';
import { statsTimeframeToOffsetMap } from '../const';

export interface IGetStatsTimeBordersParams {
  timeframe: StatsTimeframe;
  timeframeShift?: number;
}

export const getStatsTimeBorders = ({
  timeframe,
  timeframeShift = 0,
}: IGetStatsTimeBordersParams): Pick<
  IUsageDataMRPCRequestParams,
  'end' | 'start'
> => {
  const now = new Date();

  const offset = statsTimeframeToOffsetMap[timeframe];
  const shift = offset * timeframeShift;

  const start = new Date(now.getTime() - offset - shift).toISOString();
  const end = new Date(now.getTime() - shift).toISOString();

  return { end, start };
};
